import { render, staticRenderFns } from "./DealCandidateSummary.vue?vue&type=template&id=198335d0"
import script from "./DealCandidateSummary.vue?vue&type=script&lang=js"
export * from "./DealCandidateSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports